import { render, staticRenderFns } from "./HsCodesConfigurationPopup.vue?vue&type=template&id=1b18b5f4&"
import script from "./HsCodesConfigurationPopup.vue?vue&type=script&lang=js&"
export * from "./HsCodesConfigurationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports